<template>
  <div :style="styleObject">
    <button
      style="display: none;"
      type="button"
      class="btn-notification-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalNotification"
    ></button>
    <button
      style="display: none;"
      type="button"
      class="btn-close-notification-modal"
      data-bs-dismiss="modal"
      data-bs-target="#modalNotification"
    ></button>
    <div
      class="modal fade"
      :class="{ 'mlx-notify': theme2 }"
      id="modalNotification"
      tabindex="-1"
      aria-labelledby="modalNotificationLabel"
      aria-hidden="true"
      style="z-index: 999999 !important"
      data-bs-backdrop="static"
    >
      <!-- KSK033: kiosk theme 2. MOO (isKiosk=false) keeps the markup below unchanged. -->
      <KskModalShell v-if="isKiosk" :width="680" :show-close="false">
        <div class="ksk-notify">
          <div class="ksk-notify__icon" :class="{ 'ksk-notify__icon--error': error }">
            <span class="material-icons-round">{{ error ? "error_outline" : "info" }}</span>
          </div>
          <h2 v-if="isItemNotFound" class="ksk-notify__title">{{ $t("kiosk.notify.itemNotFound") }}</h2>
          <input
            v-if="isItemNotFound"
            class="search-input-notification ksk-notify__search"
            type="text"
            v-model="searchKeyword"
            @input="onChangeSearchKeyword"
          >
          <div class="ksk-notify__message" v-html="message"></div>
        </div>
        <template #footer>
          <!-- `btn-close-modal` stays: other kiosk code closes popups with a
               page-wide $(".btn-close-modal").click(). -->
          <button
            type="button"
            class="btn-close-modal ksk-notify__ok"
            data-bs-dismiss="modal"
            @click="closeModalNotificationHandler(!isItemNotFound)"
          >
            {{ $t("kiosk.common.ok") }}
          </button>
        </template>
      </KskModalShell>
      <div v-else class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center text-bold">
            <div v-if="isItemNotFound" style="font-size: 32px; font-weight: bold; margin-bottom: 10px;">Item not found</div>
            <div v-if="isItemNotFound">
              <input
                class="search-input-notification"
                type="text" 
                v-model="searchKeyword"
                style="
                  position: absolute;
                  opacity: 0;
                  pointer-events: auto;
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                "
                @input="onChangeSearchKeyword"
              >
            </div>
            <div v-html="message"></div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn-close-modal"
              data-bs-dismiss="modal"
              @click="closeModalNotificationHandler(!isItemNotFound)"
            >
              Ok
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { localStorageName } from "@/config/utils";
import KskModalShell from "@/views/kiosk/components/ui/KskModalShell.vue";

export default {
  name: "ModalNotification",
  components: {
    KskModalShell,
  },
  props: {
    message: {
      type: String,
      default: "",
    },
    isKiosk: {
      type: Boolean,
      default: false,
    },
    // Kiosk: show the message as an error (red icon) instead of info.
    error: {
      type: Boolean,
      default: false,
    },
    // MTH079: opt-in theme2 skin. Kiosk and Order.vue share this component,
    // so the new look only applies where the caller asks for it.
    theme2: {
      type: Boolean,
      default: false,
    },
    closeModalNotificationHandler: {
      type: Function,
      default: () => { },
    },
    onChangeSearchKeyword: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      searchKeyword: "",
      intervalId: null,
      isItemNotFound: false,
    };
  },
  mounted() {
    const enableRetailMode = localStorage.getItem(localStorageName("KIOSK_MODE")) ?? 0;

    if (enableRetailMode == 1) {
      this.intervalId = setInterval(() => {
        $('.search-input-notification').focus();
      }, 100);
    }
  },
  computed: {
    styleObject() {
      const accent =
        this.$store.state.mainThemeColorTheme2 || this.$store.state.color;
      return {
        "--color": this.$store.state.color,
        "--mlx-accent": accent,
        "--mlx-btn": this.$store.state.primaryButtonColorTheme2 || accent,
      };
    },
  },
  unmounted() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  },
  watch: {
    message() {
      this.searchKeyword = '';
      this.isItemNotFound = this.message.includes('item not found');
    }
  },
};
</script>

<style scoped>
.modal {
  overflow-y: hidden !important;
}

.modal-dialog {
  top: 50%;
  transform: translate(0, -50%) !important;
}

.btn-close-modal {
  border: 1px solid orangered;
  background-color: orangered;
  border-radius: 5px;
  color: #ffffff;
  padding: 5px 30px;
}

/* KSK033 — P16 kiosk notification (theme 2), isKiosk only. */
.ksk-notify {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.ksk-notify__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
}
.ksk-notify__icon--error {
  background: color-mix(in srgb, var(--ksk-error) 12%, #ffffff);
  color: var(--ksk-error);
}
.ksk-notify__icon .material-icons-round {
  font-size: 42px;
}
.ksk-notify__title {
  margin: var(--ksk-space-2) 0 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
/* Retail scanner input: invisible, covers the card so it keeps focus. */
.ksk-notify__search {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
}
.ksk-notify__message {
  margin-top: var(--ksk-space-2);
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 600;
  color: var(--ksk-text);
  overflow-wrap: anywhere;
}
.btn-close-modal.ksk-notify__ok {
  flex: 1 1 auto;
  height: 80px;
  padding: 0 var(--ksk-space-4);
  border: none;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
  box-shadow: var(--ksk-shadow-float);
  font-family: var(--ksk-font);
  font-size: var(--ksk-label-size);
  line-height: var(--ksk-label-lh);
  font-weight: 600;
  cursor: pointer;
}
.btn-close-modal.ksk-notify__ok:active {
  transform: scale(0.97);
  background: var(--ksk-primary-pressed);
}

/* MTH079 — theme2 skin, opted in via the `theme2` prop (MyCart only).
   Everything above stays untouched for kiosk / Order.vue. */
.mlx-notify {
  /* Bootstrap writes inline padding-left/right on .modal to compensate for the
     scrollbar, which pushes the centred card off-axis. Reset both. */
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.mlx-notify .modal-dialog {
  max-width: 22rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.mlx-notify .modal-content {
  border: none;
  border-radius: 1.25rem;
  box-shadow: 0 20px 40px rgba(25, 28, 30, 0.18);
  overflow: hidden;
}

.mlx-notify .modal-body {
  padding: 1.75rem 1.25rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.45;
  color: #201a1a;
}

.mlx-notify .modal-footer {
  border-top: none;
  padding: 0 1.25rem 1.5rem;
}

.mlx-notify .btn-close-modal {
  width: 100%;
  border: none;
  border-radius: 9999px;
  background-color: var(--mlx-btn, var(--color));
  color: #ffffff;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.8rem 1rem;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.mlx-notify .btn-close-modal:active {
  transform: scale(0.97);
}
</style>
